import { HermesAnalytics } from '@workivate/tho-web-shared';

const instance = HermesAnalytics.AnalyticsEngine({
  measurementId: window.WAM.ENV.analyticsMeasurementId || '',
  debug: !IS_PRODUCTION,
  gtag: typeof window !== 'undefined' ? window.gtag : undefined,
});

export default instance;
